import React from 'react';
import loadingGif from '../../../../assets/gifs/loading.gif.js';
import styles from './LoadingDots.scss.js';

const LoadingDots = _ref => {
  let {
    loadingText
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("img", {
    src: loadingGif,
    alt: "loading",
    className: styles.dots
  }), /*#__PURE__*/React.createElement("p", {
    className: styles['loading-message']
  }, loadingText));
};
var LoadingDots$1 = LoadingDots;

export { LoadingDots$1 as default };
//# sourceMappingURL=LoadingDots.js.map
